<template>
  <v-dialog v-model="dialog" width="400px" persistent>
    <v-card>
      <v-card-title class="pa-6"> Xóa nhóm đầu điểm </v-card-title>
      <v-card-text class="pa-6 pt-0">
        <div>Bạn đang yêu cầu xoá nhóm đầu điểm. Thao tác này sẽ làm ảnh hưởng đến các đầu điểm trong nhóm.</div>
        <div>Bạn chắc chắn muốn thực hiện thao tác này?</div>
      </v-card-text>
      <v-card-actions class="pa-6 pt-0">
        <BaseButton text="Hủy" outlined @click="closePopup" />
        <v-spacer />
        <BaseButton text="Đồng ý" @click="onDelete" />
      </v-card-actions>
    </v-card>
    <PopupDeleteGroupChild ref="child-popup" @onRemain="closePopup" @onRefresh="$emit('onRefresh')" />
  </v-dialog>
</template>
<script>
import { mapActions } from 'vuex'
import BaseButton from '../../../../components/basic/BaseButton.vue'
import PopupDeleteGroupChild from './PopupDeleteGroupChild.vue'
export default {
  components: {
    PopupDeleteGroupChild,
    BaseButton,
  },
  data() {
    return {
      dialog: false,
      loading: false,
      groupMark: null,
    }
  },
  methods: {
    ...mapActions({
      removeMarksIndependent: 'gradeMark/delete',
    }),
    openPopup(groupMark) {
      this.groupMark = groupMark
      this.dialog = true
    },
    closePopup() {
      this.dialog = false
      this.refresh()
    },
    refresh() {
      Object.assign(this.$data, this.$options.data.apply(this))
    },
    async onDelete() {
      this.loading = true
      try {
        await this.removeMarksIndependent(this.groupMark.id)
        this.$alert.success('Xóa nhóm đầu điểm thành công')
        this.confirmDeleteSingle()
        this.$emit('onRefresh')
      } catch (error) {
        this.$alert.error(error)
      }
      this.loading = false
    },
    confirmDeleteSingle() {
      const { children } = this.groupMark
      if (Array.isArray(children) && children.length) this.$refs['child-popup'].openPopup(this.groupMark)
    },
  },
}
</script>
